import { TouchableOpacity, View } from "react-native"
import MyLeadsConnectView from "@/components/properties/myleads/MyLeadsConnectView"
import { router } from "expo-router"
import { useViewedCallback } from "@/analytics/react"
import CloseButton from "@/assets/icons/white-close-button.svg"
import { myLeadsDeclinedClicked } from "@/analytics/events/properties"
import { setStatusBarStyle } from "@/stores/statusBarStyle"
import BFText from "@/components/standard/BFText"
import { BFScreen } from "@/components/standard/screen/BFScreen"
import useBrowserInfo from "@/hooks/useBrowserInfo"
import MyLeadsConnectCarouselAView from "@/components/properties/myleads/MyLeadsConnectCarouselAView"
import { useMyLeadsBoostFeature } from "@/hooks/useMyLeadsBoostFeature"
import MyLeadsConnectCarouselBView from "@/components/properties/myleads/MyLeadsConnectCarouselBView"

const MyLeadsConnectScreen: React.FC = () => {
  const { myLeadsEnabled } = useMyLeadsBoostFeature()
  const { featureIsEnabled: myLeadsBoostEnabled, variation } =
    useMyLeadsBoostFeature()
  const { isEmbeddedBrowser } = useBrowserInfo()

  const onDecline = () => {
    myLeadsDeclinedClicked()
    router.replace("/properties")
  }

  useViewedCallback(() => {
    setStatusBarStyle("light")
    if (myLeadsEnabled) {
      router.replace("/properties/")
    }

    // EN-4481
    if (isEmbeddedBrowser) {
      router.push("/properties/myleads/redirect")
    }
  }, [myLeadsEnabled, isEmbeddedBrowser])

  return (
    <BFScreen
      dark={true}
      headerSticky={false}
      noBackButton={true}
      gradientBackground={true}
      className="flex flex-col flex-1"
      header={
        myLeadsBoostEnabled ? null : (
          <View className={"justify-between flex-row p-6"}>
            <BFText className="text-white text-[24px] font-figtree-extrabold">
              My Leads
            </BFText>
            <TouchableOpacity
              testID={"close-button"}
              hitSlop={16}
              onPress={onDecline}
            >
              <CloseButton width={28} height={28} />
            </TouchableOpacity>
          </View>
        )
      }
    >
      {/* Manage A/B LD test from here */}
      {myLeadsBoostEnabled ? (
        variation === "treatment_1" ? (
          <MyLeadsConnectCarouselAView onDismiss={onDecline} />
        ) : variation === "treatment_2" ? (
          <MyLeadsConnectCarouselBView onDismiss={onDecline} />
        ) : (
          <MyLeadsConnectView darkTheme={true} onDismiss={onDecline} />
        )
      ) : (
        <MyLeadsConnectView darkTheme={true} onDismiss={onDecline} />
      )}
    </BFScreen>
  )
}

export default MyLeadsConnectScreen
